import { Events } from '../utils/events'
import { WorkerProcess } from './service-worker-process'

class WorkerUtils {
  static async init(shouldInitListeners = true) {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    if ((!'serviceWorker') in navigator)
      WorkerUtils.initWorkerInCurrentProcess()
    else if (window.isCordovaApk || true) {
      WorkerUtils.ungerigsterAllWorkers()
      WorkerUtils.initWorkerInCurrentProcess()
    } else {
    }
    if (shouldInitListeners) {
      WorkerUtils.initListeners()
    }
  }

  static ungerigsterAllWorkers() {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      for (const registration of registrations) {
        if (/worker-notif/i.test(registration?.active.scriptURL)) {
          registration.unregister()
        }
        // console.log(registration)
      }
    })
  }

  static async anyWorkerAvailable(timeout = 1000) {
    const anyWorkerAvailable = await new Promise(resolve => {
      Events.sendDataRequest('pingWorker', () => {
        resolve(true)
      })
      setTimeout(() => {
        resolve(false)
      }, timeout)
    })
    return anyWorkerAvailable
  }

  static initWorkerInCurrentProcess() {
    console.log('will init worker in current process')
    WorkerProcess.initEventsListener()
    WorkerProcess.initServices()
  }

  static initListeners() {
    // Events.handleEvent('initial_worker_activated', () => {
    //   setTimeout(() => {
    //     WorkerUtils.initServiceWorker('service-worker-full.js')
    //   }, 1000)
    // })
    window.parent.addEventListener('focus', () => {
      WorkerUtils.init(false)
    })
    window.parent.addEventListener('resume', () => {
      WorkerUtils.init(false)
    })
  }

  static async initServiceWorker(sourceFile) {
    if (!sourceFile) {
      console.error('fouce file not found for worer initiation')
      return
    }
    const worker = navigator.serviceWorker
    await worker
      .register(sourceFile, { type: 'module' })
      .then(async () => {
        console.log('Service worker registered')
        const anyWorkerAvailable = await WorkerUtils.anyWorkerAvailable()
        if (!anyWorkerAvailable) {
          console.log('service worker registered but do worker response')
          WorkerUtils.initWorkerInCurrentProcess()
        }
        return true
      })
      .catch(error => {
        console.error('Service worder registration failed', error)
        WorkerUtils.initWorkerInCurrentProcess()
        return false
      })

    worker.ready.then(registration => {
      registration.active.postMessage({
        name: 'service_worker_ready',
        data: {},
      })
    })
  }
}
export { WorkerUtils }
